<template>
  <div class="app-container">
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<style lang="scss">
.app-container {
  overflow: hidden;
  height: 100vh;
}
.v-enter {
  opacity: 0;
  transform: translateX(100%);
}

.v-leave-active,
.v-enter-active {
  transition: all 0.5s ease;
}
</style>
<script>

export default {
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {},
  methods: {
  }
};
</script>
